<template>
    <div id="app">
        <router-view v-if="isShow" />
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import {getFrontConfig} from "@/api/common"

export default {
    name: 'App',
    data() {
        return {
            isShow: false
        }
    },
    created() {
        getFrontConfig().then(res => {
            this.$store.state.global.textConfig = res.data

            // console.log(res)
            this.isShow = true
        })

        document.title = ''
        let cookie = Cookies.get('SYSTEM-INFO')
        let systemInfo = cookie ? JSON.parse(cookie) : {}
        for (const infoItem in systemInfo) {
            if (Object.hasOwnProperty.call(systemInfo, infoItem)) {
                const item = systemInfo[infoItem];
                for (const key in item) {
                    if (Object.hasOwnProperty.call(item, key)) {
                        try {
                            this.$store.state.projectConfig[infoItem][key] = item[key]
                        } catch (e) {
                        }
                    }
                }
            }
        }
        // let favicon = document.querySelector('link[rel="icon"]');
        // favicon.href = this.$store.state.projectConfig.tab.icon;
        document.title = this.$store.state.projectConfig.tab.name; // 动态修改网站标题
        let icon = this.$store.state.projectConfig.tab.icon;
        if (icon.length) {
            let $favicon = document.createElement("link");
            $favicon.rel = "icon";
            const config_env = require(`./build/${process.env.BUILD_ENV}.js`)
            $favicon.href = (icon.indexOf('http') === -1 ? config_env.BASE_URL + '/' : '') + icon;
            document.head.appendChild($favicon);
        }
    }
}
</script>
